import { useRegisterSW } from 'virtual:pwa-register/react';
import { Boton } from '../components/ui';
import { useInstalar } from './instalar';
import { NOMBRE_APP } from '../marca';

// Lo que hace que la web se comporte como app: registra el service worker (que
// guarda la cáscara y trae las versiones nuevas) y ofrece instalarla.
//
// Vive fuera de las pantallas: se muestra también en "Entrar". En iPhone eso
// importa, porque la app instalada tiene su propia sesión, separada de la de
// Safari: conviene instalarla ANTES de poner el PIN, así se pone una sola vez.

/** Cada cuánto se fija si hay versión nueva mientras la app está abierta. */
const CADA_CUANTO_REVISAR_MS = 60 * 60 * 1000;

let revisando = false;

function revisarVersionesNuevas(registro: ServiceWorkerRegistration) {
  if (revisando) return;
  revisando = true;
  const revisar = () => void registro.update().catch(() => {});
  setInterval(revisar, CADA_CUANTO_REVISAR_MS);
  // Al volver a la app (que en el celular queda abierta días), revisar enseguida.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') revisar();
  });
}

export function ActualizacionApp() {
  // autoUpdate (ver vite.config.ts): la versión nueva se aplica sola.
  useRegisterSW({
    onRegisteredSW(_url, registro) {
      if (registro) revisarVersionesNuevas(registro);
    },
  });
  return null;
}

export function CapaApp({ conBarraAbajo }: { conBarraAbajo: boolean }) {
  const instalar = useInstalar();
  if (instalar.tipo === 'oculto') return null;

  return (
    <>
      {/* Espacio en el flujo del mismo alto que la tarjeta: sin esto, la tarjeta
          (que flota) tapa los últimos nombres de la lista y no hay forma de
          subirlos por encima. Desaparece con la tarjeta. */}
      <div aria-hidden className="h-60 shrink-0" />
      <div
        role="status"
        aria-live="polite"
        // Sobre la barra de abajo cuando la hay (la barra mide 4rem), al pie si no.
        className={`fixed inset-x-0 z-40 mx-auto max-w-md px-3
          ${conBarraAbajo ? 'bottom-[calc(4.5rem+env(safe-area-inset-bottom))]' : 'bottom-[calc(1rem+env(safe-area-inset-bottom))]'}`}
      >
        <div className="rounded-2xl border border-(--color-acento) bg-(--color-panel) p-4 shadow-2xl">
          <p className="font-semibold">Instalá {NOMBRE_APP} en el celular</p>

          {instalar.tipo === 'android' ? (
            <>
              <p className="mt-1 text-sm text-(--color-apagado)">
                Queda un ícono en la pantalla de inicio y se abre directo, sin buscar el link.
              </p>
              <div className="mt-3 flex gap-2">
                <Boton ancho chico onClick={() => void instalar.instalar()}>
                  Instalar
                </Boton>
                <Boton tipo="secundario" chico onClick={instalar.posponer}>
                  Ahora no
                </Boton>
              </div>
            </>
          ) : (
            <>
              <p className="mt-1 text-sm text-(--color-apagado)">
                Así queda un ícono y no tenés que buscar el link. En Safari, tocá{' '}
                <strong className="text-(--color-texto)">Compartir</strong> (el cuadrado con la
                flecha) y después{' '}
                <strong className="text-(--color-texto)">Agregar a inicio</strong>.
              </p>
              <p className="mt-2 text-xs text-(--color-apagado)">
                La primera vez que la abras desde el ícono te va a pedir el PIN: es normal, el
                iPhone la trata como otra app.
              </p>
              <div className="mt-3">
                <Boton tipo="secundario" chico ancho onClick={instalar.posponer}>
                  Entendido
                </Boton>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
